<template>
  <div class="ChaptersIntroduction" :class="{'has-btn': hasBtn}">
    <div class="ChaptersIntroduction__screen">
      <div class="ChaptersIntroduction__bg" />
      <div class="ChaptersIntroduction__gradient" :style="{ backgroundImage: getGradient() }" />
      <div class="ChaptersIntroduction__title">
        <img :src="require('./img/logo_' + lang + '.png')" />
        <div class="ChaptersIntroduction__subtitle">{{ trans('subtitle') }}</div>
      </div>
    </div>
    <div class="ChaptersIntroduction__screen" :style="{ backgroundColor: chapter.colors.secondary }">
      <InstructionsBlock />
    </div>
  </div>
</template>

<script>
import InstructionsBlock from '@/components/instructions-block/InstructionsBlock'

export default {
  name: 'Introduction',
  components: { InstructionsBlock },
  beforeDestroy() {
    this.$store.commit('app/IS_INTRODUCTION', false)
    this.$tl.kill()
  },
  translations: {
    en: { subtitle: 'An illustrated journey into the heart of Canadian democracy' },
    fr: { subtitle: 'Un voyage illustré au cœur de la démocratie canadienne' },
  },
  data: () => ({
    chapter: null,
    hasBtn: false
  }),
  created() {
    this.$tl = new TimelineMax({ id: 'Chapter' })
    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter )
    this.chapter.$tl.add(this.$tl, 0)
  },
  mounted() {
    this.$tl.time(this.chapter.$tl.time())
    this.$tl
      .to(this.$el, 2, { yPercent: -100, onStart: () => this.hasBtn = true, onComplete: ()=>{   
          this.$store.commit('app/IS_INTRODUCTION', true)
      }})
  },
  methods: {
    getGradient() {
      const startColor = this.hexToRGB(this.chapter.colors.secondary, 0)
      return `linear-gradient(to bottom, ${startColor} 20%, ${this.chapter.colors.secondary})`
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.ChaptersIntroduction
  height 100%
  width 100%
  position absolute
  top 0
  left 0

  .InstructionsBlock__btn
    display none

  &.has-btn
    .InstructionsBlock__btn
      display block

  .InstructionsBlock
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)

  &__screen
    height 100%
    position relative

  &__bg
    position absolute
    top 0
    left 0
    height 100%
    width 100%
    background-image url('./img/bg.jpg')
    background-position center center
    background-size cover

  &__gradient
    position absolute
    top 0
    left 0
    height 100%
    width 100%

  &__title
    position absolute
    left 50%
    transform translateX(-50%)
    top 12vh
    width 70%

  &__subtitle
    padding-top 24px
    text-align center

  &__text
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    font-size 20px
    line-height 24px
    +below(phone)
      width 70%
      text-align center

</style>
